import { render } from "./CustomerInvoiceEdit.vue?vue&type=template&id=5b0f4408&scoped=true"
import script from "./CustomerInvoiceEdit.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceEdit.vue?vue&type=script&lang=js"

import "./CustomerInvoiceEdit.vue?vue&type=style&index=0&id=5b0f4408&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0f4408"]])

export default __exports__